// Шаблон, заказанный адресом: `/?template=beach`.
//
// Так кнопка со страницы шаблона (src/pages/TemplatesPage.tsx) доводит человека
// до собранного варианта. Ссылка обычная, а не переход внутри приложения:
// страница шаблона открыта из поиска, планировщик там ещё не загружен, и
// разбирать поручение всё равно пришлось бы после загрузки.
//
// Поручение разовое: адрес чистится сразу, ещё до применения. Иначе обновление
// страницы собирало бы шаблон заново поверх начатой работы, а «назад» в
// браузере возвращало бы к тому же.
import { useEffect, useRef } from 'react';
import type { AppState } from '../types';
import type { Translate } from '../i18n';
import { navigate } from '../router';
import { TRIP_TEMPLATES, withTemplate } from './catalog';

export function useTemplateFromQuery(
  query: URLSearchParams,
  state: AppState,
  apply: (next: AppState) => void,
  t: Translate,
): void {
  const done = useRef(false);

  useEffect(() => {
    const id = query.get('template');
    if (!id || done.current) return;

    done.current = true;

    // Убирается только само поручение: рядом может ехать ?lang= или присланный
    // вид, и стирать их заодно значило бы менять человеку язык на полпути.
    const rest = new URLSearchParams(query);
    rest.delete('template');
    const search = rest.toString();
    navigate(search ? `/?${search}` : '/', { replace: true });

    // Незнакомый id молча игнорируется: адрес уже почищен, и человек попадает
    // в обычный пустой планировщик, а не в сообщение об ошибке, которого он
    // ничем не заслужил.
    const tpl = TRIP_TEMPLATES.find((item) => item.id === id);
    if (tpl) apply(withTemplate(state, tpl, t));
  }, [query, state, apply, t]);
}
